// extracted by mini-css-extract-plugin
module.exports =  {"DownloadButton":"IkfQktIZD5hEiVBKAoMC"};